import axios from 'axios'

const BASE = '/comprobantes/comprobantes'

/**
 * Arma el query string del listado de facturas de compra.
 * Todos los filtros son opcionales y viajan al backend (ComprobanteFilter).
 */
function buildQuery(params = {}) {
    const {
        page,
        rowsPerPage,
        sucursal_uuid,
        estado_pago,
        search,
        desde,
        hasta,
        proveedor,
        ordering,
    } = params

    const query = new URLSearchParams()
    query.set('esVenta', 'false')
    query.set('doc', 'FC|NP')

    if (page) query.set('page', page)
    if (rowsPerPage) query.set('page_size', rowsPerPage)
    if (sucursal_uuid) query.set('uuid_sucursal', sucursal_uuid)
    if (estado_pago) query.set('estado_pago', estado_pago)
    if (search) query.set('search', search)
    if (desde) query.set('desde', desde)
    if (hasta) query.set('hasta', hasta)
    if (proveedor) query.set('proveedor', proveedor)
    if (ordering) query.set('ordering', ordering)

    return query.toString()
}

export default {
    index(params) {
        return axios.get(`${BASE}?${buildQuery(params)}`)
    },

    /**
     * Totales del mismo conjunto que devuelve index(): cantidad, total,
     * pagado, saldo, apertura por estado, top de proveedores y por mes.
     */
    resumen(params) {
        return axios.get(`${BASE}/resumen?${buildQuery(params)}`)
    },

    show(id) {
    },

    update(id, data) {

    },
    anular(id) {
        var url = `/comprobantes/compra/eliminar/${id}`

        return axios.get(url)

    },

    create(data) {
    },
    /**
     * Nota de crédito del proveedor por importe (bonificación o pronto pago),
     * colgada de la factura. Sin número queda "pendiente de emisión".
     */
    registrarNotaCredito(idFactura, data) {
        return axios.post(`/comprobantes/compra/${idFactura}/notas-credito`, data)
    },
    completarNumeroNotaCredito(idNota, data) {
        return axios.patch(`/comprobantes/compra/notas-credito/${idNota}`, data)
    },
    payment(data) {
        var url = `/comprobantes/compra/pagar`
        return axios.post(url, data)
    },
    actualizarFechaContable(id, fecha_contable) {
        var url = `/comprobantes/compra/actualizar/${id}`
        var data = { fecha_contable: fecha_contable }
        return axios.put(url, data)
    }


}
